import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFavoriteExerciseSession } from '../../../../api/diary-service';

const useCreateExerciseSession = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createFavoriteExerciseSession,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['favoriteExerciseSessions'] });
        }
    });
};

export default useCreateExerciseSession;
